export default __webpack_public_path__ + "facebook-logo-1.png";